import React from "react";
import ReactDOM from "react-dom";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import "./plugins/i18n";
import "./plugins/api";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import { PersistGate } from "redux-persist/integration/react";

import store, { persistedStore } from "store/store";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
        <SnackbarProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </SnackbarProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
